module.exports = __webpack_public_path__ + "img/dg.d59574c4.png";